// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__ZbNPS","close":"Modal_close__UIz8V","box":"Modal_box__DVppY","content":"Modal_content__BfTZm"};